import React from "react";
import MainApp from "./components/MainApp";
import Login from "./components/backend/login/Login";
import { ThemeProvider } from "@mui/material/styles";
import theme from "./theme";
import { useAuth } from "./components/utils/AuthContext";

function App() {
    const { isAuthenticated } = useAuth();

    return (
        <ThemeProvider theme={theme}>
            {isAuthenticated ? <MainApp /> : <Login />}
        </ThemeProvider>
    );
}

export default App;
